export default __webpack_public_path__ + "static/media/app.83f82d7d.png";